export const portfolioProjects = [
  {
    slug: 'edunode',
    name: 'EduNode',
    tagline: 'Educational platform for STEM, Web3 and AI',
    description: 'Educational platform for STEM, WEB3 and AI',
    category: 'Own Brand · EdTech · Web3',
    website: 'https://edunode.org/',
    github: 'https://github.com/EduNodeOrg?tab=repositories',
    logo: 'https://pbs.twimg.com/profile_images/1307989699357749251/Be0jAooe_400x400.jpg',
    logoAlt: 'EduNode Logo',
    status: 'Live product · Grant-funded',
    technology: ['Web3', 'Stellar', 'AI', 'Open Source'],
    features: [
      'STEM Education Platform',
      'Web3 Integration',
      'AI-Powered Learning',
      'Grant-funded by Stellar Development Foundation'
    ],
    tags: ['Education', 'STEM', 'Web3', 'AI', 'Open Source'],
    overview: 'EduNode is an educational platform developed under OG Technologies covering STEM, Web3, and AI topics. Developed with support from the Stellar Development Foundation through its grant program, the platform combines learning content with hands-on blockchain integration and AI-powered learning support.',
    keyCapabilities: [
      'STEM education platform with Web3 and AI learning tracks',
      'Blockchain integration built on the Stellar ecosystem',
      'AI-powered learning support and personalization',
      'Open-source components maintained under the EduNodeOrg GitHub organization'
    ],
    businessRelevance: 'EduNode demonstrates OG Technologies\' ability to design, fund, and ship its own products at the intersection of education and decentralized technology. It reflects hands-on expertise in the Stellar ecosystem, grant-funded open-source development, and applied AI in learning experiences.',
    cta: 'Visit edunode.org to explore the platform, or contact OG Technologies to discuss education technology and Web3 integration.',
    metaTitle: 'EduNode - STEM, Web3 & AI Education Platform',
    metaDescription: 'EduNode is OG Technologies\' educational platform for STEM, Web3, and AI — grant-funded by the Stellar Development Foundation with open-source components.',
    metaKeywords: 'EduNode, education platform, STEM education, Web3 learning, AI learning, Stellar Development Foundation grant, open source education'
  },
  {
    slug: 'mozart-pay',
    name: 'Mozart Pay',
    tagline: 'Payment platform using Stellar Network and Circle USDC/EURC',
    description: 'Payment platform using Stellar Network and Circle USDC/EURC',
    category: 'Own Brand · FinTech · Payments',
    website: 'https://mozartpay.com/',
    github: 'https://github.com/mozartpay?tab=repositories',
    logo: 'https://pbs.twimg.com/profile_images/1346878845622890506/GPNnoIeT_400x400.jpg',
    logoAlt: 'MozartPay Logo',
    status: 'Live product',
    technology: ['Stellar', 'Circle USDC/EURC', 'Payment Infrastructure'],
    features: [
      'Stellar Network Integration',
      'USDC/EURC Support',
      'Cross-border Payments',
      'Decentralized Finance'
    ],
    tags: ['FinTech', 'Blockchain', 'Payments', 'Stellar', 'DeFi'],
    overview: 'Mozart Pay is a payment platform developed under OG Technologies, built on the Stellar network with Circle USDC and EURC stablecoin settlement. The platform targets fast, low-cost cross-border payments on open, interoperable infrastructure.',
    keyCapabilities: [
      'Cross-border payments settled on the Stellar network',
      'Circle USDC and EURC stablecoin support',
      'Fast, low-cost settlement leveraging Stellar\'s ~5-second ledger finality',
      'Open-source components maintained under the mozartpay GitHub organization'
    ],
    businessRelevance: 'Mozart Pay reflects OG Technologies\' expertise in payment infrastructure, regulated stablecoins, and Stellar ecosystem development. It shows how regulated digital assets like USDC and EURC can power practical cross-border payment products.',
    cta: 'Visit mozartpay.com to explore the platform, or contact OG Technologies to discuss payment infrastructure and Stellar integration.',
    metaTitle: 'Mozart Pay - Stellar Payment Platform with USDC/EURC',
    metaDescription: 'Mozart Pay is OG Technologies\' Stellar-based payment platform using Circle USDC/EURC for fast, low-cost cross-border payments.',
    metaKeywords: 'Mozart Pay, Stellar payments, USDC, EURC, Circle stablecoins, cross-border payments, blockchain payments, DeFi'
  },
  {
    slug: 'stellar-go-cli',
    name: 'Stellar Go CLI',
    tagline: 'Open-Source Developer Toolkit',
    description: 'Open-source command-line toolkit for the Stellar ecosystem, built in Go',
    category: 'Open Source · Blockchain Infrastructure · Developer Tools',
    website: null,
    github: 'https://github.com/stellar-go-cli/stellar-go-cli',
    logo: null,
    logoAlt: null,
    status: 'Open source · Apache 2.0',
    technology: ['Go', 'Stellar', 'Soroban', 'Distributed Ledger Technology'],
    features: [
      'Stellar blockchain & payment tooling',
      'W3C DIDs & ISO 20022 reporting',
      'Soroban RPC client & MCP server',
      'Apache 2.0 open source'
    ],
    tags: ['Go', 'Stellar', 'Soroban', 'CLI', 'Open Source', 'DLT'],
    overview: 'The Stellar Go CLI is an open-source command-line toolkit developed under OG Technologies to support development and integration within the Stellar ecosystem. Built in Go, the project aims to provide developers with practical tools for blockchain interactions, payment workflows, and interoperable digital infrastructure.',
    keyCapabilities: [
      'Stellar blockchain and payment tooling — wallets, payments, and swaps',
      'SEP-41 token asset support and a pure-Go Soroban RPC client',
      'Developer utilities for working with Stellar-based applications',
      'Support for interoperability-related workflows, including W3C DIDs, Verifiable Credentials, and ISO 20022 financial reporting',
      'MCP server exposing CLI capabilities to AI assistants',
      'Open-source tooling designed to support integration and developer productivity'
    ],
    businessRelevance: 'The project reflects OG Technologies\' expertise in blockchain infrastructure, payment technology, open-source engineering, and interoperability. It demonstrates how specialised developer tools can help address practical integration challenges in distributed ledger ecosystems.',
    cta: 'Explore the source code on GitHub or contact OG Technologies to discuss enterprise blockchain integration and developer tooling.',
    metaTitle: 'Stellar Go CLI - Open-Source Stellar Developer Toolkit',
    metaDescription: 'Open-source Go CLI for Stellar: wallets, payments, swaps, SEP-41 assets, W3C DIDs/Verifiable Credentials, ISO 20022 reporting, Soroban RPC, and an MCP server. Apache 2.0.',
    metaKeywords: 'Stellar Go CLI, Stellar CLI, Go blockchain tools, Soroban, SEP-41, W3C DIDs, Verifiable Credentials, ISO 20022, MCP server, open source'
  },
  {
    slug: 'stellar-cpp-sdk',
    name: 'Stellar C++ SDK',
    tagline: 'Open-Source C++ SDK for the Stellar Network',
    description: 'Open-source C++ SDK for building Stellar integrations — protocol types, XDR encoding, and transaction building blocks',
    category: 'Open Source · Blockchain Infrastructure · SDK',
    website: null,
    github: 'https://github.com/Olvisgil/stellar-cpp-sdk',
    logo: null,
    logoAlt: null,
    status: 'Open source · Apache 2.0',
    technology: ['C++', 'Stellar', 'CMake', 'XDR', 'Distributed Ledger Technology'],
    features: [
      'Stellar protocol types & XDR encoding',
      'Transaction building blocks for C++ applications',
      'CMake-based cross-platform build',
      'Apache 2.0 open source'
    ],
    tags: ['C++', 'Stellar', 'SDK', 'CMake', 'Open Source', 'DLT'],
    overview: 'The Stellar C++ SDK is an open-source library developed under OG Technologies for integrating applications with the Stellar network from C++. It provides protocol-level foundations — Stellar types, XDR encoding, and transaction building blocks — for high-performance or embedded integrations where managed SDKs in higher-level languages are not an option.',
    keyCapabilities: [
      'Stellar protocol types and primitives expressed in modern C++',
      'XDR (External Data Representation) support matching the Stellar protocol',
      'Building blocks for accounts, keys, and transaction construction',
      'CMake-based build system designed for cross-platform and embedded use',
      'Test suite and CI workflows included',
      'Open-source tooling released under the Apache 2.0 license'
    ],
    businessRelevance: 'The SDK reflects OG Technologies\' low-level blockchain engineering — working directly at the protocol and serialization layer rather than wrapping higher-level libraries. It demonstrates the ability to deliver Stellar integrations in performance-sensitive and embedded environments beyond the usual JavaScript and Go toolchains.',
    cta: 'Explore the source code on GitHub or contact OG Technologies to discuss C++ and embedded blockchain integration.',
    metaTitle: 'Stellar C++ SDK - Open-Source Stellar Client Library',
    metaDescription: 'Open-source C++ SDK for the Stellar network — protocol types, XDR encoding, and transaction building blocks with a CMake build. Apache 2.0.',
    metaKeywords: 'Stellar C++ SDK, Stellar C++, cpp stellar sdk, Stellar client library, blockchain C++, XDR, open source, Stellar integration'
  }
];
